import React from "react";
import YoutubeEmbed from "./YoutubeEmbed";

const YouTubeVideo = () => {
  return (
    <div className="flex justify-center items-center my-10">
      <div className="">
        <iframe
          width="560"
          height="315"
          className="rounded-lg"
          src="https://www.youtube.com/embed/-EeQbaRH-fw?autoplay=1"
          title="YouTube video player1"
        ></iframe>
      </div>
    </div>
  );
};

export default YouTubeVideo;
